import RepositoryService from 'src/services/repository'

const resource = 'criticalChain/session'

export default RepositoryService.utils.createCrudRepository(resource)
